import { render } from "./Consecutivos.vue?vue&type=template&id=628bc072"
import script from "./Consecutivos.vue?vue&type=script&lang=js"
export * from "./Consecutivos.vue?vue&type=script&lang=js"

import "./Consecutivos.vue?vue&type=style&index=0&id=628bc072&lang=css"
script.render = render

export default script